



























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TabItem } from './tabItem';
import { HeaderButton } from './headerButton';
import { Route } from 'vue-router';

@Component
export default class PageHeader extends Vue {
	@Prop() public title: string;
	@Prop() public description: string;
	@Prop() public tabs: TabItem[];
	@Prop() public buttons: HeaderButton[];

	public activeRoute: Route = {} as Route;

	@Watch('$route', { immediate: true })
	public onRoute(to: Route, from: Route) {
		this.activeRoute = to;
	}

	public hasTabs() {
		return this.tabs && this.tabs.length > 0;
	}

	public hasButtons() {
		return this.buttons && this.buttons.length > 0;
	}

	public isTabActive(tab: TabItem): boolean {
		return this.isTabTheActiveRoute(tab) || this.isNoExactMatchAndActiveRouteBeginsWithTabsPath(tab);
	}

	private isTabTheActiveRoute(tab: TabItem) {
		return this.activeRoute.name === tab.route;
	}

	private isNoExactMatchAndActiveRouteBeginsWithTabsPath(tab: TabItem) {
		return !this.isAnyTabActive() && this.doesActiveRouteBeginWithPath(tab.route);
	}

	private isAnyTabActive(): boolean {
		return this.tabs.filter(tab => this.activeRoute.name === tab.route).length > 0;
	}

	private doesActiveRouteBeginWithPath(routeName: string): boolean {
		const path: string = this.getRoutePath(routeName);
		return !!this.activeRoute.path && this.activeRoute.path.indexOf(path) === 0;
	}

	private getRoutePath(routeName: string): string {
		const allRoutes: Route[] = (this.$router as any).options.routes;
		const matchedRoutes: Route[] = allRoutes.filter(route => route.name === routeName || route.name === '/' + routeName);
		return matchedRoutes.length === 1 ? matchedRoutes[0].path : '';
	}
}
